import React, { useState } from 'react';
import './PasswordGate.css';

/**
 * PasswordGate Component
 * Simple password protection for the entire site
 */

const PasswordGate = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Check password against environment variable
    const correctPassword = process.env.REACT_APP_SITE_PASSWORD || 'password1234';

    setTimeout(() => {
      if (password === correctPassword) {
        // Store authentication in sessionStorage (lasts until browser closes)
        sessionStorage.setItem('isocentral_authenticated', 'true');
        onAuthenticated();
      } else {
        setError('Incorrect password. Please try again.');
        setPassword('');
      }
      setIsLoading(false);
    }, 500);
  };

  return (
    <div className="password-gate">
      <div className="password-gate-container">
        <div className="password-gate-header">
          <img src="/logo.png" alt="IsoCentral" className="password-gate-logo" />
          <h1>IsoCentral</h1>
          <p className="password-gate-subtitle">Player Directory</p>
        </div>

        <form onSubmit={handleSubmit} className="password-gate-form">
          <div className="form-group">
            <label htmlFor="password">Enter Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password to access"
              autoFocus
              disabled={isLoading}
              className={error ? 'error' : ''}
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <button 
            type="submit" 
            disabled={!password || isLoading}
            className="submit-button"
          >
            {isLoading ? 'Checking...' : 'Access Directory'}
          </button>
        </form>

        <div className="password-gate-footer">
          <p>🏀 Authorized Access Only</p>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;
